// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33QWu","delete":"styles_delete__1v2kc","update":"styles_update__18nfB","add":"styles_add__2dThJ"};